import { ContactDetailsFormNew_MX } from './mixed';

export const ContactDetailsFormNew = {
  SPB: ContactDetailsFormNew_MX,
};
